var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('label',{staticClass:"radio-button"},[_c('input',{attrs:{"type":"radio","name":_vm.group,"value":"value"}}),_c('span')])])}
var staticRenderFns = []

export { render, staticRenderFns }